import { CtaButton, IBasicUserType } from '@zappyrent/hundop';
import { rem, rgba } from 'polished';
import styled from 'styled-components/macro';

export const StyledFieldset = styled.fieldset<IBasicUserType>`
  margin: 0;
  border: none;
  padding: 0;
`;

export const StyledTitle = styled.h4`
  margin: ${rem('40px')} 0 0 0;
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${rem('20px')};
  font-weight: 600;
`;

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    flex-direction: row;
    min-height: 100vh;
  }
`;
export const StyledContainer = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    flex: 0 0 36.8%;
    padding: ${rem('66px')} ${rem('40px')} 0 ${rem('24px')};
    background-color: ${({ theme }) => theme.colors.cross.ultralightGray};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    flex-basis: 37%;
  }
`;
export const StyledEditButton = styled.button<IBasicUserType>`
  position: absolute;
  top: ${rem('2px')};
  right: 0;
  z-index: 100;
  display: flex;
  margin: 0;
  padding: 0;
  color: ${({ disabled, theme, user }) =>
    user &&
    (disabled ? theme.colors.cross.silverFox : theme.colors[user].main)};
  font-size: ${rem('16px')};
  font-weight: 700;
  text-decoration: underline;
  background-color: transparent;
  border: none;
  cursor: ${({ disabled }) => (disabled ? `default` : `pointer`)};
  appearance: none;
`;

export const StyledContinueButton = styled.button<IBasicUserType>`
  text-transform: uppercase;
  margin: 0;

  span {
    position: relative;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.tenant.mainAlternate};
  }
  color: ${({ disabled, theme, user }) =>
    user &&
    (disabled ? theme.colors.cross.silverFox : theme.colors[user].main)};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    max-width: ${rem('264px')};
    width: 100%;
  }
`;
export const StyledButton = styled(CtaButton)`
  text-transform: uppercase;
  margin: 0;

  span {
    position: relative;
  }
  cursor: pointer;
  display: flex;
  justify-content: center;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    max-width: ${rem('264px')};
    width: 100%;
  }
`;
export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end; // Aligns children (button) to the right
`;
export const StyledFooter = styled.header`
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
    background-color: ${({ theme }) => theme.colors.main};
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    height: ${rem('72px')};
    z-index: 10;
    box-shadow: ${({ theme }) =>
      `0 0 ${rem('8px')} ${rgba(theme.colors.cross.silverFox, 0.5)}`};
  }
  width: 100%;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    padding-top: ${rem('74px')};
    clip-path: ${`inset(0px ${rem('-8px')} 0px 0px)`};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    flex-basis: 19.7%;
  }
`;

export const StyledMissingFieldTitle = styled.h4`
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  font-size: ${rem('16px')};
  margin-bottom: ${rem('10px')};
  margin-top: 0;
`;

export const StyledMissingFieldWrapper = styled.div`
  margin-bottom: ${rem('30px')};
`;

export const StyledMissingFieldLabel = styled.h4`
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  font-size: ${rem('14px')};
  margin: 0;
`;

export const StyledMissingFieldLabelsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${rem('8px')};
  margin-bottom: ${rem('8px')};
`;

export const StyledMissingFieldsText = styled.span`
  background-color: ${({ theme }) => rgba(theme.colors.cross.red, 0.1)};
  color: ${({ theme }) => theme.colors.cross.red};
  border-radius: ${rem('8px')};
  padding: ${rem('4px')} ${rem('8px')};
  font-weight: 600;

  display: inline-flex;
  align-items: center;
  gap: ${rem('8px')};
  font-size: ${rem('12px')};
`;
